import uuid from 'uuid/v1';

import { INTEGRATIONS_CONSTANTS } from 'constants/base';

const getFuturePrices = (isUpdate, futurePricesForm) => {
 
  const values = Object.values(futurePricesForm);
 

  let ratePlanIds = Object.keys(futurePricesForm)
    .filter(key => !isNaN(Number(key)) && futurePricesForm[key] === true) 
    .map(key => Number(key))


  // Only enter object extraction if we have objects with valid ratePlanId properties
  const objectsWithRatePlanId = values.filter(
    val => typeof val === 'object' && val !== null && !Array.isArray(val) && val.ratePlanId !== undefined
  );
  

  if (objectsWithRatePlanId.length > 0) {
    
    ratePlanIds = objectsWithRatePlanId
      .map(item => Number(item.ratePlanId))
      .filter(id => !isNaN(id)); // Filter out any NaN values
    
  }

  // Final safety filter to remove any NaN values
  ratePlanIds = ratePlanIds.filter(id => !isNaN(id));

  
  return ratePlanIds;
};

const getActivtyFuturePrices = (isUpdate, activityFuturePricesForm) => {
  

  // If it's already an array, extract ratePlanIds
  if (Array.isArray(activityFuturePricesForm)) {
    
    const result = activityFuturePricesForm
      .map(item => Number(item.ratePlanId))
      .filter(id => !isNaN(id));
    
    return result;
  }
  
  const values = Object.values(activityFuturePricesForm);
  
  // Check for checkbox format: keys like 'selected_123' with value true  
  let ratePlanIds = Object.keys(activityFuturePricesForm)
    .filter(key => key.startsWith('selected_') && activityFuturePricesForm[key] === true)
    .map(key => Number(key.replace('selected_', '')));
  
  
  // Only extract from objects if they have valid ratePlanId property
  const objectsWithRatePlanId = values.filter(
    val => typeof val === 'object' && val !== null && !Array.isArray(val) && val.ratePlanId !== undefined
  );
  

  if (objectsWithRatePlanId.length > 0) {
    
    ratePlanIds = objectsWithRatePlanId
      .map(item => Number(item.ratePlanId))
      .filter(id => !isNaN(id));
   
  }

  // Final safety filter to remove any NaN values
  ratePlanIds = ratePlanIds.filter(id => !isNaN(id));
  
  
  return ratePlanIds;
};

const getAddOns = (isUpdate, addOnsForm, secondLanguage) => {
  return addOnsForm.addOns.map(item => {
    const countryCode = 'No';
    let prices = getPreparedPricesCurrency(item);
    let secondLanguageFields = {};

    if (secondLanguage) {
      secondLanguageFields = {
        [`title${countryCode}`]: item[secondLanguage].title,
        [`description${countryCode}`]: item[secondLanguage].description
      };
    } else {
      secondLanguageFields = {
        [`title${countryCode}`]: null,
        [`description${countryCode}`]: null
      };
    }

    const idObj = isUpdate && item.isCreated ? { id: parseInt(item.id) } : {};

    return {
      ...idObj,
      title: item.title,
      description: item.description,
      photo:
        item.coverPhoto.file || item.coverPhoto.image
          ? item.coverPhoto.file || item.coverPhoto.image
          : null,
      ...secondLanguageFields,
      prices: prices
    };
  });
};

const getMandatoryFees = (isUpdate, mandatoryFeesForm, secondLanguage) => {
  return mandatoryFeesForm.mandatoryFees.map(item => {
    const countryCode = 'No';
    let prices = getPreparedPricesCurrency(item);
    let secondLanguageFields = {};

    if (secondLanguage) {
      secondLanguageFields = {
        [`title${countryCode}`]: item[secondLanguage].title,
        [`description${countryCode}`]: item[secondLanguage].description
      };
    } else {
      secondLanguageFields = {
        [`title${countryCode}`]: null,
        [`description${countryCode}`]: null
      };
    }

    const idObj = isUpdate && item.isCreated ? { id: parseInt(item.id) } : {};

    return {
      ...idObj,
      title: item.title,
      description: item.description,
      
      ...secondLanguageFields,
      prices: prices
    };
  });
};

const getPreparedPricesCurrency = item => {
  let prices = [];

  ['USD', 'EUR', 'NOK'].map(fieldName => {
    if (item[fieldName] && item[fieldName].length) {
      if (item[fieldName] === 'undefined') item[fieldName] = '0';
      prices.push({
        participant: item.participant,
        currency: fieldName,
        value: parseFloat(item[fieldName].split(',').join(''))
      });
    }
  });

  return prices;
};

const getCurrencyValue = (prices, currency) => {
  const foundElement = prices.find(
    price => price.currency.currency === currency
  );
  if (foundElement) return foundElement.value.toString();
  return '0';
};

const getIntegrations = (isUpdate, integrationForm) => {
  return integrationForm.integrations.map(item => {
    const idObj = isUpdate && item.isCreated ? { id: parseInt(item.id) } : {};

    return {
      ...idObj,
      platform: INTEGRATIONS_CONSTANTS[item.platform] || item.platform,
      titleOnPlatform: item.titleOnPlatform
    };
  });
};

const getPricesFixedForm = data => {
  const categoriesPrices = {};

  data.prices.map(item => {
    categoriesPrices[item.participant.participant || 'Adult'] = {
      ...categoriesPrices[item.participant.participant || 'Adult'],
      [item.currency.currency]: item.value.toString()
    };
  });

  const fixedPrice = Object.keys(categoriesPrices).map(field => ({
    USD: categoriesPrices[field]['USD'] || '0',
    EUR: categoriesPrices[field]['EUR'] || '0',
    NOK: categoriesPrices[field]['NOK'] || '0'
  }));

  return fixedPrice[0];
};

const getPricesCategoryForm = data => {
  const categoriesPrices = {};

  data.prices.map(item => {
    categoriesPrices[item.participant.participant || 'Adult'] = {
      ...categoriesPrices[item.participant.participant || 'Adult'],
      [item.currency.currency]: item.value.toString()
    };
  });

  return {
    categories: Object.keys(categoriesPrices).map(field => ({
      id: uuid(),
      participant: field,
      USD: categoriesPrices[field]['USD'] || '0',
      EUR: categoriesPrices[field]['EUR'] || '0',
      NOK: categoriesPrices[field]['NOK'] || '0'
    }))
  };
};

const getRatePlanPrices = (data) => {
 

  const futurePrices = data?.futurePrices || [];
  
  return futurePrices.map((priceGroup) => {
    

    const firstPrice = priceGroup.ratePlanPrices[0];

    const prices = priceGroup.ratePlanPrices.reduce((acc, p) => {
      acc[p.currency.currency] = p.value.toString();
      return acc;
    }, {});

    return {
      ratePlanId: priceGroup.ratePlan.id,
      ratePlanTitle: priceGroup.ratePlan.title,
      startDate: firstPrice.startDate,
      endDate: firstPrice.endDate,
      prices,
    };
  });
};

const getActivtyRatePlanPrices = (data) => {

  const activityRatePlans = data?.futurePrices || [];
 
  
  const result = [];

  activityRatePlans.forEach((item) => {
    const groupedByParticipant = {};

  
    const prices = item.ratePlanPrices || [];
    
  
    prices?.forEach((price) => {
      const participant = price?.participant?.participant;
      if (!groupedByParticipant[participant]) {
        groupedByParticipant[participant] = [];
      }
      groupedByParticipant[participant].push(price);
    });

 
    Object.entries(groupedByParticipant).forEach(([participant, priceList]) => {
      const pricesByCurrency = priceList.reduce((acc, p) => {
        acc[p.currency.currency] = p.value.toString();
        return acc;
      }, {});

      result.push({
        ratePlanId: Number(item.ratePlan.id),
        ratePlanTitle: item.ratePlan.title,
        participant,
        startDate: priceList[0].startDate,
        endDate: priceList[0].endDate,
        prices: pricesByCurrency,
      });
    });
  });

  return result;
};

// Returns checkbox-compatible format for futurePricesForm initialization
// Used when editing an accommodation to pre-check the selected rate plans
const getRatePlanCheckboxStates = (data) => {
  
  
  const futurePrices = data?.futurePrices || [];
  const checkboxStates = {};
  
  futurePrices.forEach((priceGroup) => {
    const ratePlanId = priceGroup.ratePlan?.id;
    if (ratePlanId !== undefined) {
      checkboxStates[ratePlanId] = true;
    }
  });
  
  
  return checkboxStates;
};

// Returns checkbox-compatible format for activityFuturePricesForm initialization
// Used when editing an activity to pre-check the selected rate plans
// Note: Activity checkboxes use 'selected_${id}' format
const getActivityRatePlanCheckboxStates = (data) => {
  
  
  const futurePrices = data?.futurePrices || [];
  const checkboxStates = {};
  
  futurePrices.forEach((priceGroup) => {
    const ratePlanId = priceGroup.ratePlan?.id;
    if (ratePlanId !== undefined) {
      checkboxStates[`selected_${ratePlanId}`] = true;
    }
  });
  
  
  return checkboxStates;
};



export {
  getFuturePrices,
  getActivtyFuturePrices,
  getAddOns,
  getMandatoryFees,
  getPreparedPricesCurrency,
  getCurrencyValue,
  getIntegrations,
  getPricesFixedForm,
  getPricesCategoryForm,
  getRatePlanPrices,
  getActivtyRatePlanPrices,
  getRatePlanCheckboxStates,
  getActivityRatePlanCheckboxStates
};
